import { render, staticRenderFns } from "./PuiDocumentNotificacionModals.vue?vue&type=template&id=63b1759c"
import script from "./PuiDocumentNotificacionModals.vue?vue&type=script&lang=js"
export * from "./PuiDocumentNotificacionModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports